<template>
  <div class="wrapper">
    <DropDownSelect class="w-full">
      <template #activator="{ open }">
        <button
          class="group btn-link-neutral-s relative my-3 flex h-9 w-48 justify-between border border-solid py-2"
          :class="{ 'border-error text-error': error, 'border-strong': !error }"
          :data-testid="`csv-upload-column-btn-${name}`"
          @click.prevent="open"
        >
          <div>
            <span
              class="absolute"
              :class="{
                'top-2 left-3': props.value === null || props.value === undefined,
                '-top-3 left-2 bg-surface px-1 text-label-s': !(props.value === null || props.value === undefined),
              }"
            >
              {{ t(name) }}
            </span>
            <span v-if="props.value !== null && props.value !== undefined" class="absolute top-2 left-3 text-body-m text-main">
              {{ getItemText }}
            </span>
          </div>
          <div>
            <SvgIcon
              v-if="props.value !== null && props.value !== undefined"
              :path="mdiClose"
              class="opacity-0 group-hover:opacity-100"
              :size="20"
              @click="selectionChanged(null, open)"
            />
            <SvgIcon :path="mdiMenuDown" class="mr-2" :size="22" />
          </div>
        </button>
      </template>
      <template #default="{ close }">
        <ul class="m-0 w-[175px] list-none p-0">
          <li
            v-for="item in itemsForSelect"
            :key="item.text"
            :class="{ 'cursor-events-none': item.disabled }"
            :data-testid="`csv-upload-column-option-${name}-${item.value}`"
            class="cursor-pointer px-2 py-2 text-center hover:bg-surface-elevation-2"
            @click="item.disabled ? '' : selectionChanged(item.value, close)"
          >
            <span :class="{ 'text-main': !item.disabled, 'text-subtle': item.disabled }">{{ item.text }}</span>
          </li>
        </ul>
      </template>
    </DropDownSelect>

    <div v-if="tooltip">
      <SvgIcon
        v-tooltip="{ content: tooltip, html: true, placement: 'right' }"
        :path="mdiInformationOutline"
        :size="24"
        class="text-success"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { mdiClose, mdiMenuDown, mdiInformationOutline } from '@mdi/js'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  value?: number | null
  name: string
  itemsForSelect: Array<{ text: string; value: number | null; disabled: boolean }>
  required: boolean
  error: boolean
}>()

const emit = defineEmits<{
  (e: 'mappingChanged', value: number | null): void
}>()

function selectionChanged(value: number | null, callback: () => void) {
  callback()
  emit('mappingChanged', value)
}

const getItemText = computed(() => {
  const foundItem = props.itemsForSelect.find((item) => {
    return item.value === props.value
  })
  if (!foundItem) return 'undefined'
  return foundItem.text
})

const tooltip = computed(() => {
  if (props.name == 'gender') {
    return `
      <h4>${t('EmailInvitationQuota.mapping.tips.gender.male_values')}:</h4>
      <ul>
        <li>m</li>
        <li>male</li>
        <li>Herr</li>
        <li>männlich</li>
      </ul>
      <br>
      <h4>${t('EmailInvitationQuota.mapping.tips.gender.female_values')}:</h4>
      <ul>
        <li>f</li>
        <li>female</li>
        <li>Frau</li>
        <li>weiblich</li>
      </ul>
    `
  } else if (props.name == 'cc') {
    return t('EmailInvitationQuota.mapping.tips.cc')
  } else if (props.name == 'externalId') {
    return t('EmailInvitationQuota.mapping.tips.externalId')
  }

  return null
})
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

:deep(body) {
  background: rgb(239, 241, 243);
}
</style>
